import axios from "axios";
import qs from "qs";
import LoginService from "./LoginService";
import UtilityService from "./UtilityService";
import createAuthRefreshInterceptor from "axios-auth-refresh";

let http = null;
let sessionExpired = false;

class ApiService {
  constructor() {
    http = axios.create({
      baseURL: process.env.VUE_APP_API_URL,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      paramsSerializer: params => {
        return qs.stringify(params, { arrayFormat: "repeat" });
      }
    });

    // Function that will be called to refresh authorization
    const refreshAuthLogic = failedRequest =>
      new Promise((resolve, reject) => {
        if (sessionExpired) {
          reject();
          return;
        }
        LoginService.refreshToken().then(
          tokenRefreshResponse => {
            // this.setToken(tokenRefreshResponse.data.access_token);
            failedRequest.response.config.headers["Authorization"] =
              "Bearer " + tokenRefreshResponse.data.access_token;
            resolve();
          },
          error => {
            this.sessionExpiredHandler(error);
            reject();
          }
        );
      });

    // Instantiate the interceptor (you can chain it as it returns the axios instance)
    createAuthRefreshInterceptor(http, refreshAuthLogic);

    http.interceptors.response.use(
      response => {
        this.sendPostMessage("xhr");

        if (response && response.data && response.data.access_token) {
          LoginService.setAccessToken(response.data.access_token);
          LoginService.setRefreshToken(response.data.refresh_token);
        }

        return response && response.data && response.data._embedded
          ? response.data._embedded
          : response;
      },
      function(error) {
        console.log("ajax-response", error);
        return Promise.reject(error);
      }
    );
  }

  sessionExpiredHandler(error) {
    console.log("EXPIRED SESSION ---", error);
    sessionExpired = true;
    UtilityService.cleanAll();
    window.vm.$root.$emit("EXPIRED_SESSION");
    window.vm.$router.push("/");
    UtilityService.showErrorModal("Sessione scaduta");
    this.sendPostMessage("sessionExpired");
  }

  sendPostMessage(action) {
    const fromApp = LoginService.getFromApp();
    if (fromApp) {
      UtilityService.sendPostMessage({
        action: action
      });
    } else {
      console.log("postmessage --> ", action);
    }
  }

  getAxios() {
    return http;
  }

  setToken(token) {
    console.log(`Setting API authorization token`);
    http.defaults.headers.common.Authorization = `Bearer ${token}`;
  }

  removeToken() {
    http.defaults.headers.common.Authorization = "";
  }

  get(resource, request = {}, options = {}) {
    return http.get(`${resource}`, {
      params: request,
      ...options
    });
  }

  post(resource, query) {
    return http.post(resource, query);
  }

  put(resource, query) {
    return http.put(resource, query);
  }

  patch(resource, query) {
    return http.patch(resource, query);
  }

  delete(resource, query) {
    return http.delete(resource, query);
  }

  getApiUrl() {
    return process.env.VUE_APP_API_URL;
  }
}

export default new ApiService();
